const config = {
  SYSTEM_EXTERNAL_URL: "https://news.varso.org",
};

export default config;
